export default {
  lignes_pending: false,
  lignes: []
}
